import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Calendar } from "lucide-react";

const WystepSwiateczny = () => (
  <SeoPageLayout title="Występ komediowy" titleAccent="na wigilię firmową">
    <SeoSection title="Komik na wigilię firmową">
      <p>Wigilia firmowa to jedno z najważniejszych wydarzeń roku w każdej firmie. To moment podsumowania, podziękowań i wspólnego świętowania. Profesjonalny występ komediowy nadaje wigilii wyjątkowy charakter i sprawia, że pracownicy wspominają ją przez cały następny rok.</p>
    </SeoSection>

    <SeoSection title="Dlaczego komik na wigilii firmowej?">
      <SeoStyledList items={[
        "Podsumowanie roku z humorem - komik żartobliwie komentuje najważniejsze wydarzenia firmy",
        "Przełamanie oficjalnej atmosfery - śmiech jednoczy zespół",
        "Alternatywa dla karaoke i konkursów - coś naprawdę wyjątkowego",
        "Profesjonalna rozrywka, która nie wymaga aktywnego udziału gości",
        "Idealne uzupełnienie kolacji wigilijnej i wręczenia prezentów"
      ]} />
    </SeoSection>

    <SeoSection title="Świąteczny materiał komediowy">
      <p>Okres świąteczny to kopalnia komediowego materiału - od korporacyjnych tradycji prezentowych, przez firmowe Secret Santa, po grudniową gorączkę zamykania projektów. Nasz komik nawiąże do tych uniwersalnych doświadczeń, dodając spersonalizowane elementy o Twojej firmie.</p>
    </SeoSection>

    <SeoSection title="Rezerwacja na okres świąteczny">
      <p>Grudzień to nasz najbardziej intensywny okres - wigilię firmowe odbywają się zazwyczaj w pierwszych trzech tygodniach grudnia. Aby zagwarantować dostępność najlepszego komika, rekomendujemy rezerwację z co najmniej 4-6 tygodniowym wyprzedzeniem. Im wcześniej się skontaktujesz, tym lepiej dobierzemy termin i przygotujemy materiał.</p>
      <SeoHighlightBox icon={Calendar}>
        Grudzień to najgorętszy okres - zarezerwuj komika na wigilię firmową z minimum 4-6 tygodniowym wyprzedzeniem!
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default WystepSwiateczny;
